t = require('app/scripts/views/internal/teacup-with-helpers')('pop_over_ad')

module.exports = ->
  t.a '.icon-sm.icon-close.dark-hover.ad-close.js-close-ad', { href: '#' }
  t.mustacheBlock 'iconClass', ->
    t.span { class: 'pop-over-ad-icon ' + t.mustacheVar('iconClass') }
  t.div '.ad-copy', ->
    t.raw t.mustacheVar('copyHtml')
